import React from 'react';
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { imageURl } from '../../libs/env';

const ShowAudioModal = ({ audioData, isOpen, toggle }) => {

//   useEffect(() => {
//     // Check if the audio is playing and handle audio end event
//     const audioElement = new Audio(audioData?.audio_url);
//     audioElement.muted = true;
//     audioElement.addEventListener('ended', handleAudioEnd);
//     audioElement.play();

//     // Cleanup function to remove event listener
//     return () => {
//       audioElement.removeEventListener('ended', handleAudioEnd);
//     };
//   }, [audioData]);

return (
    <Modal
    isOpen={isOpen}
    size="md"
    backdrop="static"
    toggle={toggle}
    className="modal-dialog-centered "
  >
    <ModalBody className='text-center p-4'>
        <div className="text-end">
            <button onClick={toggle} className="btn p-0 me-2 ">
                <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
            </button>
        </div>
        <h4 className="text-darkblue mb-3">
            <strong>{audioData?.label}</strong>
        </h4>
        <div className="audio-popup">
            <audio id='playaudio' class="audio-size" src={audioData?.audio_url} controls autoPlay onEnded={toggle} ></audio>
        </div>
    </ModalBody>
  </Modal>
  );
};

ShowAudioModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ShowAudioModal.defaultProps = { isOpen: false, };

export default ShowAudioModal;